import { skipToken, useQuery } from '@tanstack/react-query'
import {
  fetchCart,
  fetchCartCustomerInfo,
  fetchCartImages,
  fetchCartsWithImages,
  fetchMyCarts,
} from '../queries/carts.queries'

export const useMyCarts = () =>
  useQuery({
    queryKey: ['myCarts'],
    queryFn: fetchMyCarts,
  })

export const useCart = (id: number) =>
  useQuery({
    queryKey: ['cart', id],
    queryFn: () => {
      if (Number.isNaN(id)) {
        return null
      }
      return fetchCart(id)
    },
  })

export const useCartCustomerInfo = (cartId: number | null) =>
  useQuery({
    queryKey: ['cartCustomerInfo', cartId],
    queryFn: cartId == null ? skipToken : () => fetchCartCustomerInfo(cartId),
  })

export const useCartsWithImages = (page: number, pageSize: number, storeId: number | null) =>
  useQuery({
    queryKey: ['cartsWithImages', page, pageSize, storeId],
    queryFn: () => fetchCartsWithImages(page, pageSize, storeId),
  })

export const useCartImages = (cartId: number | null) =>
  useQuery({
    queryKey: ['cartImages', cartId],
    queryFn: cartId == null ? skipToken : () => fetchCartImages(cartId),
  })
